import { trapFocus } from "@common/utilities.js";
export default class LinkNavigation {
	constructor(config) {
		this.el = config.el;
		this.dropdownEl = this.el.querySelector(".js-link-navigation-dropdown");
		this.dropdownToggleEl = this.el.querySelector(
			".js-link-navigation-dropdown-toggle"
		);
		this.dropdownListEl = this.el.querySelector(
			".js-link-navigation-dropdown-list"
		);
		this.dropdownVisible = false;
		this.init();
	}
	init() {
		this.attachEvents();
	}
	attachEvents() {
		this.dropdownToggleEl.addEventListener(
			"click",
			this.toggleDropdown.bind(this)
		);

		// close on esc if focus is inside
		this.dropdownEl.addEventListener("keydown", (e) => {
			if (e.code === "Escape" && this.dropdownVisible) {
				this.closeDropdown();
			}
		});

		// close when focus leaves menu
		this.dropdownEl.addEventListener("focusout", (e) => {
			if (!this.dropdownVisible) {
				return;
			}

			const currentTarget = e.currentTarget;
			// Give browser time to focus the next element
			requestAnimationFrame(() => {
				// Check if the new focused element is a child of the original container
				if (!currentTarget.contains(document.activeElement)) {
					this.closeDropdown();
				}
			});
		});

		trapFocus(this.dropdownListEl);
	}
	toggleDropdown() {
		if (this.dropdownVisible) {
			this.closeDropdown();
		} else {
			this.openDropdown();
		}
	}
	closeDropdown() {
		this.dropdownVisible = false;
		this.dropdownToggleEl.setAttribute("aria-expanded", false);
		this.dropdownToggleEl.classList.remove("active");
		this.dropdownListEl.classList.remove("active");
	}
	openDropdown() {
		this.dropdownVisible = true;
		this.dropdownToggleEl.setAttribute("aria-expanded", true);
		this.dropdownToggleEl.classList.add("active");
		this.dropdownListEl.classList.add("active");
	}
}
